// routes/_terms.mio.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_terms.mio')

export const handle = { name: 'mio' }

export default dynamic(getClientModule, { ssr: false })
